import { apiRoutes } from "@constants/api-routes";
import { RequestTypes } from "@enums/request-types";
import { handleRequest } from "@utils/http-util";

export const logOutRequest = async () => {
    const route = apiRoutes.axnadminCore.logOut;
    const { error } = await handleRequest(RequestTypes.GET, route);
    return { error };
};